// import colors from 'vuetify/lib/util/colors'
export default {
  blue: "#6D72B6",
  pink: "#D864A5",
  green: "#4AB790",
  yellow: "#F1DA55",
  orange: "#F5876B",
  error: "#ee0000",
};
